import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CampaignCardMetrics } from "./CampaignCardMetrics";
import { CampaignCardPress } from "./CampaignCardPress";

const NarrativeBlock = ({ label, body }) => (
  <div>
    <div className="text-[10px] tracking-[0.22em] uppercase opacity-50 mb-1.5">
      {label}
    </div>
    <p className="text-sm md:text-base leading-relaxed text-[var(--muted)]">
      {body}
    </p>
  </div>
);

export const CampaignCardBody = ({ campaign: c, index, reverse }) => (
  <div
    className={`col-span-12 md:col-span-5 ${
      reverse ? "md:order-1" : ""
    } reveal`}
  >
    <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-3">
      {c.brand}
    </div>
    <Link
      to={`/case/${c.slug}`}
      data-testid={`campaign-title-link-${index}`}
      className="inline-block group/title"
    >
      <h3 className="text-3xl md:text-5xl font-bold tracking-tight leading-[1.02] mb-4 group-hover/title:opacity-60 transition-opacity">
        {c.title}
      </h3>
    </Link>
    <p className="text-lg md:text-2xl font-medium tracking-tight leading-snug text-[var(--ink)] mb-6 md:mb-8">
      &ldquo;{c.tagline}&rdquo;
    </p>

    <div className="space-y-4 md:space-y-5 mb-8">
      <NarrativeBlock label="The Challenge" body={c.challenge} />
      <NarrativeBlock label="The Idea" body={c.solution} />
    </div>

    <CampaignCardMetrics campaign={c} index={index} />

    <Link
      to={`/case/${c.slug}`}
      data-testid={`campaign-read-${index}`}
      className="mt-6 md:mt-8 inline-flex items-center gap-2 border border-[var(--ink)] px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium hover:bg-[var(--ink)] hover:text-[var(--paper)] transition-colors"
    >
      Read the full case study
      <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.75} />
    </Link>

    <CampaignCardPress press={c.press} />
  </div>
);
